import React, { useEffect, useState, useCallback, useRef } from "react";

import Icon_PDF from "../../../Assets/img/pdf_icon.svg";
import Icon_XLS from "../../../Assets/img/xls_icon.svg";
import Icon_JPG from "../../../Assets/img/jpg_icon.svg";
import Icon_HTML from "../../../Assets/img/html_icon.svg";
import Icon_PNG from "../../../Assets/img/png_icon.svg";
import Icon_FILE from "../../../Assets/img/file_icon.svg";

import { Tab, Tabs } from "react-bootstrap";

import "./styles.css";
import {
    ListarCasoDocumentoController,
    ListarCasoDocumentoPorContaController,
    ListarCasoDocumentoPorContaUAUController,
} from "../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { IDocumento } from "../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import ComponenteDocumentos from "./ComponenteDocumentos";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { useTransformToRef } from "../../../hooks/useTransformToRef";
import { useUserInfor } from "../../../Context/User";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { ACESSOS } from "../../../Routes/Acessos";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { useClientePage } from "../../../Context/ClientePage";
import HistoricoEmailsCliente from "./HistoricoEmailsCliente";
import DocumentosGerados from "./DocumentosGerados";

type TExibicaoDocumentos = "CASO" | "CLIENTE" | "UAU";
interface IDocumentosProps {
    IDCaso?: number;
    IdConta?: number;
    totalDocCaso?: number;
    setTotalDocCaso?: (total: number) => void;
    tipoExibicao: "CASO" | "CLIENTE";
}
interface IDocumentoComIcone extends IDocumento {
    icon_url?: string;
}

export default function Documentos(props: IDocumentosProps) {
    const { OrgInfor } = useUserInfor();
    const { listenDocChanges } = useAtendimentoPage();
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const { Cliente } = useClientePage();
    const { id } = useModuloInfo();

    const [lstDocsCaso, setLstDocsCaso] = useState<Array<IDocumentoComIcone>>();
    const [lstDocsCliente, setLstDocsCliente] =
        useState<Array<IDocumentoComIcone>>();
    const [lstDocsUAU, setLstDocsUAU] = useState<Array<IDocumentoComIcone>>();
    const [loadEmails, setLoadEmails] = useState(false);

    //const { historicoCaso } = useHistoricoContext();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const tipoExibicaoCarregados = useRef([
        props.tipoExibicao,
    ] as Array<TExibicaoDocumentos>);

    const [totalDocCaso, setTotalDocCaso] = useState(props.totalDocCaso);

    const updateDocumentosCliente = useAsyncCallback(async () => {
        if (props.IdConta) {
            return ListarCasoDocumentoPorContaController(props.IdConta).then(
                (res) => {
                    if (
                        !tipoExibicaoCarregados.current.some(
                            (tec) => tec === "CLIENTE"
                        )
                    ) {
                        tipoExibicaoCarregados.current.push("CLIENTE");
                    }
                    setLstDocsCliente(
                        PreencherIconesDocumentos(
                            res.filter((doc) => !doc.DocUAU)
                        )
                    );
                    return res;
                }
            );
        }
    });
    const updateDocumentosCaso = useAsyncCallback(async () => {
        if (props.IDCaso) {
            return ListarCasoDocumentoController(props.IDCaso).then((res) => {
                if (
                    !tipoExibicaoCarregados.current.some(
                        (tec) => tec === "CASO"
                    )
                ) {
                    tipoExibicaoCarregados.current.push("CASO");
                }
                setLstDocsCaso(
                    PreencherIconesDocumentos(res.filter((doc) => !doc.DocUAU))
                );
                return res;
            });
        }
    });
    const updateDocumentosUAU = useAsyncCallback(async () => {
        if (!tipoExibicaoCarregados.current.some((tec) => tec === "UAU")) {
            tipoExibicaoCarregados.current.push("UAU");
        }
        const docs = await ListarCasoDocumentoPorContaUAUController(
            props.IdConta ?? 0
        );
        setLstDocsUAU(
            PreencherIconesDocumentos(docs?.filter((doc) => doc.DocUAU))
        );
        return docs;
    });

    // Usando ref para não causar chamadas excessivas do callback
    // ( estava tendo problema com loop de chamadas no backend )
    const updateDocumentosClienteRef = useTransformToRef(
        updateDocumentosCliente.execute
    );
    const updateDocumentosCasoRef = useTransformToRef(
        updateDocumentosCaso.execute
    );
    const updateDocumentosUAURef = useTransformToRef(
        updateDocumentosUAU.execute
    );
    const updateDocumentosPorTipo = useCallback(
        async (tipoExibicao: TExibicaoDocumentos) => {
            if (tipoExibicao === "CLIENTE" && props.IdConta) {
                updateDocumentosClienteRef.current?.();
            } else if (tipoExibicao === "CASO" && props.IDCaso) {
                updateDocumentosCasoRef.current?.();
            } else if (tipoExibicao === "UAU") {
                updateDocumentosUAURef.current?.();
            }
        },
        [
            updateDocumentosClienteRef,
            updateDocumentosCasoRef,
            updateDocumentosUAURef,
            props.IdConta,
            props.IDCaso,
        ]
    );

    const updateDocumentos = useCallback(() => {
        tipoExibicaoCarregados.current.forEach((tipoExibicao) => {
            updateDocumentosPorTipo(tipoExibicao);
        });
    }, [updateDocumentosPorTipo]);

    useEffect(updateDocumentos, [updateDocumentos, listenDocChanges]);

    useEffect(() => {
        if (lstDocsCaso) {
            const newTotal = lstDocsCaso.length;
            setTotalDocCaso(newTotal);
            props.setTotalDocCaso?.(newTotal);
        }
    }, [lstDocsCaso, props]);

    return (
        <Tabs defaultActiveKey={props.tipoExibicao}>
            {props.tipoExibicao === "CASO" && (
                <Tab
                    title={`Documentos do Caso ( ${totalDocCaso} )`}
                    eventKey="CASO"
                    onEnter={() => {
                        if (
                            !tipoExibicaoCarregados.current.some(
                                (tec) => tec === "CASO"
                            )
                        ) {
                            updateDocumentosPorTipo("CASO");
                        }
                    }}
                >
                    <ComponenteDocumentos
                        tipoExibicao={"CASO"}
                        IDCaso={props.IDCaso}
                        IdConta={props.IdConta}
                        updateDocumentos={updateDocumentos}
                        lstDocs={lstDocsCaso}
                        loading={updateDocumentosCaso.loading}
                    />
                </Tab>
            )}
            {emccampMode === ID_ORGANIZACAO &&
            ACESSOS.ASSISTENCIA.ID_MODULO === id ? null : (
                <Tab
                    title="Documentos do Cliente"
                    eventKey="CLIENTE"
                    onEnter={() => {
                        if (
                            !tipoExibicaoCarregados.current.some(
                                (tec) => tec === "CLIENTE"
                            )
                        ) {
                            updateDocumentosPorTipo("CLIENTE");
                        }
                    }}
                >
                    <ComponenteDocumentos
                        tipoExibicao={"CLIENTE"}
                        IDCaso={props.IDCaso}
                        IdConta={props.IdConta}
                        updateDocumentos={updateDocumentos}
                        lstDocs={lstDocsCliente}
                        loading={updateDocumentosCliente.loading}
                    />
                </Tab>
            )}

            {OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                <Tab
                    title="Documentos UAU"
                    eventKey="UAU"
                    onEnter={() => {
                        if (
                            !tipoExibicaoCarregados.current.some(
                                (tec) => tec === "UAU"
                            )
                        ) {
                            updateDocumentosPorTipo("UAU");
                        }
                    }}
                >
                    <ComponenteDocumentos
                        tipoExibicao={"UAU"}
                        IDCaso={props.IDCaso}
                        IdConta={props.IdConta}
                        updateDocumentos={updateDocumentos}
                        lstDocs={lstDocsUAU}
                        loading={updateDocumentosUAU.loading}
                    />
                </Tab>
            )}

            <Tab title="Documentos Gerados" eventKey="DocumentosGerados">
                <DocumentosGerados />
            </Tab>

            {Cliente && (
                <Tab
                    title="Histórico de Emails"
                    eventKey="HistoricoEmailsCliente"
                    onEnter={() => setLoadEmails(true)}
                >
                    {loadEmails && (
                        <HistoricoEmailsCliente
                            ID_USUARIO={props.IdConta ?? 0}
                        />
                    )}
                </Tab>
            )}
        </Tabs>
    );
}

function PreencherIconesDocumentos(docs: IDocumento[]) {
    return docs.map((doc) => {
        if (doc.DS_DOCUMENTO) {
            const icon_url =
                doc.DS_DOCUMENTO?.search(/.pdf$|.PDF$/) >= 0
                    ? Icon_PDF
                    : doc.DS_DOCUMENTO?.search(/.png$|.PNG$/) >= 0
                    ? Icon_PNG
                    : doc.DS_DOCUMENTO?.search(/.jpg$|.jpeg$|.JPG$|.JPEG$/) >= 0
                    ? Icon_JPG
                    : doc.DS_DOCUMENTO?.search(/.html$|.HTML$/) >= 0
                    ? Icon_HTML
                    : doc.DS_DOCUMENTO?.search(/.xls$|.xlsx$|.XLS$|.XLSX$/) >= 0
                    ? Icon_XLS
                    : Icon_FILE;
            return {
                ...doc,
                icon_url,
            } as IDocumentoComIcone;
        } else return doc;
    });
}
